module.exports = __webpack_public_path__ + "img/58.e60af2dc.png";